/**
 * El color de la etiqueta de un rol (maqueta de Melanie: Administrador violeta,
 * Gerente comercial magenta, Vendedor gris, Analista de precios naranja). El
 * mismo rol tiene siempre el mismo color, en Usuarios y en Roles.
 */
const PALETA = [
  'bg-primary/10 text-primary',
  'bg-prixia-sky/10 text-prixia-sky dark:text-foreground',
  'bg-muted text-foreground',
  'bg-prixia-gold/10 text-prixia-gold dark:text-foreground',
  'bg-ok-suave text-ok',
];

const FIJOS: Record<string, number> = {
  administrador: 0,
  'gerente comercial': 1,
  gerente: 1,
  vendedor: 2,
  'analista de precios': 3,
  aprobador: 4,
};

export function colorDeCargo(nombre: string): string {
  const clave = nombre.trim().toLowerCase();
  if (clave in FIJOS) return PALETA[FIJOS[clave]];
  let h = 0;
  for (const c of clave) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETA[h % PALETA.length];
}
